import { imagePicker_template } from "../../../vendor/valnet/valnet_imagePicker/js/components/templates/imagePicker_template";
import { imagePickerHelper } from "../../../vendor/valnet/valnet_imagePicker/js/modules/imagePickerHelper";
import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { filterArticle_template } from "./filterArticle_template";
import { filterTag_template } from "./filterTag_template";
import { imageWidget_template } from "./imageWidget_template";

declare var ko: any;

export class channelsPlaylistsEdit_template extends vnTemplate {
    public imagePicker: imagePicker_template;
    public imagePickerHelper: imagePickerHelper;
    public imageWidgetForVideoThumbnail: imageWidget_template;
    public channelFilter: filterTag_template;
    public articleFilter: filterArticle_template;

    static CHANNEL_INFO_TAB = "info";
    static CHANNEL_PLAYLIST_TAB = "playlists";

    protected getTemplateHtml(): string {
        return /*html*/ `
        <div class="w-form view-tag playlist-form">
            <div class="form-header">
                <input id="user-id" data-bind="value: id" type="hidden">
                <!-- ko ifnot: $data.id() -->
                <h3 class="form-title icon i-playlist">Create Playlist</h3>
                <!-- /ko -->
                <!-- ko if: $data.id() -->
                <h3 class="form-title icon i-playlist">Edit Playlist</h3>
                <!-- /ko -->
                <button data-bind="event: { click: onClickCancel }" class="close-button icon i-close-2" type="button"></button>
            </div>

            <div class="form-pagination">
                <button data-bind="event: { click: onClickSelectTab.bind($data, '${channelsPlaylistsEdit_template.CHANNEL_INFO_TAB}') }, css: { 'is-activated': selectedTab() == '${channelsPlaylistsEdit_template.CHANNEL_INFO_TAB}' }" class="btn icon i-playlist" type="button"><span class="btn-text">Playlist</span></button>
                <button data-bind="event: { click: onClickSelectTab.bind($data, '${channelsPlaylistsEdit_template.CHANNEL_PLAYLIST_TAB}') }, css: { 'is-activated': selectedTab() == '${channelsPlaylistsEdit_template.CHANNEL_PLAYLIST_TAB}' }" class="btn icon i-video-2" type="button"><span class="btn-text" data-bind="text: 'Videos' + (articles().length ? ' (' + articles().length + ')' : '')"></span></button>
            </div>

            <div class="ww-form-body" data-bind="css: { 'is-showing': selectedTab() == '${channelsPlaylistsEdit_template.CHANNEL_INFO_TAB}' }">
                <div class="form-body playlists-images"  data-bind="css: { 'is-showing': true }">

                    <strong class="form-sub-title">Playlist Information</strong>

                    <div class="form-group inside-label">
                        <label for="title" class="form-label">Title</label>
                        <input id="title" data-bind="value: title" type="text" class="input-text">
                    </div>
                    <div class="form-group inside-label">
                        <label for="description" class="form-label">Description</label>
                        <textarea  id="description" name="description" data-bind="value: description"></textarea>
                    </div>

                    <div class="form-group">
                        <div class="form-check-inline">
                            <input type="checkbox" data-bind="checked: isAvailableForUse" id="isAvailableForUse">
                            <label for="isAvailableForUse" class="form-label icon i-check">Available For Use</label>
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="" class="form-label">Channel</label>
                        ${this.channelFilter.getHtmlBuild()}
                    </div>

                    <div class="form-group img">
                        <div style="border-top: 1px dashed #d3d3d3; margin-top: 3rem; padding-top: 2rem;">
                            <label for="" class="form-label">Image</label>
                            ${this.imageWidgetForVideoThumbnail.getHtmlBuild()}
                        </div>
                    </div>
                </div>
            </div>

            <div class="ww-form-body" data-bind="css: { 'is-showing': selectedTab() == '${channelsPlaylistsEdit_template.CHANNEL_PLAYLIST_TAB}' }">
                <div class="form-group">
                    <label for="" class="form-label">Video Articles</label>
                    ${ this.articleFilter.getHtmlBuild() }
                    <div class="w-filters-selected">
                        <div id="filters-selected" class="filters-selected">
                            <div id="selected-articles">
                                <!-- ko if: articles().length > 0 -->
                                    <label class="small">Selected Videos</label>
                                    <div id="selected-articles-wrapper" class="w-pinned" data-bind="foreach: articles">
                                        <div class="pinned-form entry" data-bind="attr: { 'id': id, 'data-position': position }">
                                            <div class="w-btn">
                                                <button class="btn border only-icon icon border i-link" data-bind="event: { click: $parent.onClickArticle }" type="button"></button>
                                                <button class="btn border only-icon icon border highlight i-delete" data-bind="event: { click: $parent.onClickDeleteElement }" type="button"></button>
                                            </div>
                                            <div class="w-title">
                                                <div>
                                                    <span class="pinned-info" data-bind="text: 'ID: ' + id"></span>
                                                    <p class="pinned-info" data-bind="text: 'Last Published: ' + $parent.formatDate(dateMostRecentPublishedStatus, 'Never Published')"></p>
                                                    <h5 class="pinned-title" data-bind="text: title"></h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                <!-- /ko -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-footer">
                <button data-bind="event: { click: onClickCancel }" class="btn " type="button">Cancel</button>
                <button data-bind="event: { click: onClickSave }" class="btn highlight" type="button">Save Playlist</button>
            </div>
            ${this.imagePicker.getHtmlBuild()}
        </div>

        <div id="confirm-channel-change-dialog" class="w-lightbox light-theme" data-bind="class: channelChangeDialogVisibility() ? 'is-visible' : ''">
            <div class="lightbox-content confirm-channel-change">
                <div class="w-form lightbox-form">
                    <div class="form-header">
                        <h3 class="form-title">Change Associated Channel</h3>
                        <button type="button" data-bind="event: { click: onClickToggleChannelChangeDialogVisibility }" class="close-button icon i-close-2"></button>
                    </div>
                    <div id="confirm-channel-change-body" class="form-body">
                        <div class="form-group channel-change">
                            <p class="form-text alert-error">This will clear the video list. Are you sure you want to continue?</p>
                        </div>
                        </div>
                    <div class="form-footer">
                        <button type="button" data-bind="event: { click: onClickCancelChannelChange }" class="btn">Cancel</button>
                        <button type="button" data-bind="event: { click: onClickChangeChannel }" class="btn highlight">Confirm</button>
                    </div>
                </div>
            </div>
        </div>
        `;
    }

    protected getTemplateName(): string {
        return "channelsPlaylistsEdit_template";
    }

    protected getMainElementClasses(): Array<string> {
        return [""];
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected initPartial(): void {
        this.imagePicker = new imagePicker_template("imagePicker", this.getTemplateViewModel(), this.caller);
        this.imagePickerHelper = new imagePickerHelper(
            this.imagePicker,
            this.caller.viewModel,
            this.caller.getVnAppZone(),
            this.caller,
        );

        this.channelFilter = new filterTag_template("channelFilter", this.getTemplateViewModel(), this.caller);
        this.channelFilter.setShowType(false);
        this.channelFilter.setPlaceholderText("Channel");

        this.imageWidgetForVideoThumbnail = new imageWidget_template("menu_image", this.getTemplateViewModel(), this);
        this.imageWidgetForVideoThumbnail.setMode("single-select");
        this.imageWidgetForVideoThumbnail.setCaller(this.imagePickerHelper);

        this.articleFilter = new filterArticle_template("articleFilter", this.getTemplateViewModel(), this.caller);
        this.articleFilter.setIsLoadingAnimationEnable(true);
        this.articleFilter.setSelectionMode(filterArticle_template.SINGLE_SELECTION_MODE);
        this.articleFilter.setShowDetails(true);
        this.articleFilter.setDisableField(true);
    }

    protected buildViewModel(): any {
        let self = this;

        return {
            brand: ko.observable(""),
            channelName: ko.observable(""),
            dateCreated: ko.observable(null),
            dateUpdated: ko.observable(null),
            description: ko.observable(""),
            id: ko.observable(null),
            idChannel_value: ko.observable(null),
            idChannel: ko.pureComputed({
                read: () => {
                    return self.getTemplateViewModel().idChannel_value();
                },
                write: (value) => {
                    self.getTemplateViewModel().idChannel_value(value);
                    self.articleFilter.setDisableField(!value);
                },
            }),
            isAvailableForUse: ko.observable(1),
            title: ko.observable(""),
            image: ko.observable(""),
            selectedTab: ko.observable(channelsPlaylistsEdit_template.CHANNEL_INFO_TAB),
            articles: ko.observableArray([]),

            channelChangeDialogVisibility: ko.observable(false),
            onClickToggleChannelChangeDialogVisibility: this.toggleChannelChangeDialogVisibility.bind(this),
            onClickChangeChannel: this.changeChannel.bind(this),
            onClickCancelChannelChange: this.cancelChannelChange.bind(this),
            onClickSelectTab: this.onClickSelectTab.bind(this),
            onClickDeleteElement: this.onClickDeleteElement.bind(this),
            formatDate: this.formatDate.bind(this),
            onClickArticle: this.onClickArticle.bind(this),

            onClickSave: (data) => {
                self.onClickSave();
            },
            onClickCancel: (data, event) => {
                self.onClickCancel();
            },
        };
    }

    protected formatDate(date, nullMessage) {
        let dateText = "";
        if(date) {
            let objDate = new Date(date);
            dateText = `${objDate.getDate()}/${objDate.getMonth() + 1}/${objDate.getFullYear()}`;
        } else {
            dateText = nullMessage;
        }
        return dateText;
    }

    protected onClickDeleteElement(targetArticle, event): void {
        let articles = this.getArticles();
        articles = articles.filter(article => article.id !== targetArticle.id);
        this.setArticles(articles);
    }

    protected onClickCancel(): void {
        this.caller.cancel(this.getTemplateViewModel().id());
    }

    protected onClickSave(): void {
        this.caller.save();
    }

    public setBrand(brand): void {
        this.getTemplateViewModel().brand(brand);
    }

    public setChannelName(channelName): void {
        this.getTemplateViewModel().channelName(channelName);
    }

    public setDateCreated(dateCreated): void {
        this.getTemplateViewModel().dateCreated(dateCreated);
    }

    public setDateUpdated(dateUpdated): void {
        this.getTemplateViewModel().dateUpdated(dateUpdated);
    }

    public setDescription(description): void {
        this.getTemplateViewModel().description(description);
    }

    public setId(id): void {
        this.getTemplateViewModel().id(id);
    }

    public setIdChannel(idChannel): void {
        this.getTemplateViewModel().idChannel(idChannel);
    }

    public getIDChannel(): number {
        return this.getTemplateViewModel().idChannel();
    }

    public setIsAvailableForUse(isAvailableForUse): void {
        this.getTemplateViewModel().isAvailableForUse(isAvailableForUse);
    }

    public setTitle(title): void {
        this.getTemplateViewModel().title(title);
    }

    public setImage(image): void {
        this.getTemplateViewModel().image(image);
    }

    public setPlaylist(data): void {
        this.getTemplateViewModel().channelName(data.channelName);
        this.getTemplateViewModel().dateCreated(data.dateCreated);
        this.getTemplateViewModel().dateUpdated(data.dateUpdated);
        this.getTemplateViewModel().description(data.description);
        this.getTemplateViewModel().id(data.id);
        this.getTemplateViewModel().idChannel(data.idChannel);
        this.getTemplateViewModel().isAvailableForUse(data.availableForUse);
        this.getTemplateViewModel().title(data.title);
        this.getTemplateViewModel().articles(data.articles.sort((a, b) => a.position - b.position));
        if (data.image) {
            this.imageWidgetForVideoThumbnail.setImage(data.image);
            this.setImage(data.image);
        }
        this.channelFilter.setTag({id: data.idChannel, name: data.channelName});
    }

    protected setChannelFilter(channels) {
        this.channelFilter.setTags(channels);
    }

    protected toggleChannelChangeDialogVisibility() {
        this.getTemplateViewModel().channelChangeDialogVisibility(!this.getTemplateViewModel().channelChangeDialogVisibility());
    }

    protected changeChannel() {
        this.getTemplateViewModel().articles([]);
        this.toggleChannelChangeDialogVisibility();

        this.getTemplateViewModel().idChannel(this.channelFilter.getIdTag());
        this.getTemplateViewModel().channelName(this.channelFilter.getTag());
    }

    protected cancelChannelChange() {
        this.channelFilter.setTag({
            id: this.getTemplateViewModel().idChannel(),
            name: this.getTemplateViewModel().channelName(),
        });
        this.toggleChannelChangeDialogVisibility();
    }

    public handleChannelChange() {
        if(this.channelFilter.getIdTag() != this.getTemplateViewModel().idChannel() && this.getArticles().length > 0) {
            this.toggleChannelChangeDialogVisibility();
        } else {
            this.getTemplateViewModel().idChannel(this.channelFilter.getIdTag());
            this.getTemplateViewModel().channelName(this.channelFilter.getTag());
        }
    }

    public addArticle(article) {
        if(article) {
            let articles = this.getArticles();
            if (!articles.some(a => a.id === article.id)) {
                article.position = this.getLastPosition() + 1;
                articles.push(article);
                this.setArticles(articles);
            }
        }
    }

    private getLastPosition() {
        const lastElement = document.querySelector(".pinned-form.entry:last-child") as HTMLElement;
        const position = lastElement ? lastElement.dataset.position : 0;
        return +position;
    }

    private onClickSelectTab(tab) {
        this.getTemplateViewModel().selectedTab(tab);
    }

    public getArticles() {
        return this.getTemplateViewModel().articles();
    }

    private setArticles(articles) {
        this.getTemplateViewModel().articles(articles);
    }

    public onClickArticle(article) {
        this.caller.showArticle(article);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/channelsPlaylistsEdit_template.ts